var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { instanceToPlain, plainToInstance } from 'class-transformer';
import queries from 'constants/queries';
import { PaginationMetaData, StockMovement } from 'models';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import ApiService from '../ApiService';
import StockMovementMetaInfo from 'models/appEntities/StockMovementMetaInfo';
import { useNavigate } from 'react-router';
var StockMovementService = /** @class */ (function (_super) {
    __extends(StockMovementService, _super);
    function StockMovementService() {
        var _this = _super.call(this) || this;
        _this.stockMovementsRoot = 'stock_movements';
        _this.successMessage = '';
        return _this;
    }
    StockMovementService.prototype.useStockMovements = function (pageNumber, filters) {
        var _this = this;
        if (pageNumber === void 0) { pageNumber = 1; }
        if (filters === void 0) { filters = {}; }
        return useQuery([queries.inventory.stockMovements, pageNumber, filters], function () {
            return _this.get(_this.stockMovementsRoot, __assign(__assign({}, filters), { page: pageNumber }));
        }, {
            keepPreviousData: true,
            select: function (_a) {
                var data = _a.data;
                var stockMovements = plainToInstance(StockMovement, data === null || data === void 0 ? void 0 : data.stock_movements);
                var meta = plainToInstance(PaginationMetaData, data === null || data === void 0 ? void 0 : data.meta);
                return { stockMovements: stockMovements, meta: meta };
            }
        });
    };
    StockMovementService.prototype.useStockMovement = function (id) {
        var _this = this;
        return useQuery(['show', queries.inventory.stockMovements, id], function () {
            return _this.get("".concat(_this.stockMovementsRoot, "/").concat(id));
        }, {
            retry: false,
            select: function (_a) {
                var data = _a.data;
                return plainToInstance(StockMovement, data);
            }
        });
    };
    StockMovementService.prototype.useMetaInfo = function (enabled) {
        var _this = this;
        if (enabled === void 0) { enabled = true; }
        return useQuery(['meta-', queries.inventory.stockMovements], function () {
            return _this.get("".concat(_this.stockMovementsRoot, "/meta_info"));
        }, {
            enabled: enabled,
            select: function (_a) {
                var data = _a.data;
                return plainToInstance(StockMovementMetaInfo, data);
            }
        });
    };
    StockMovementService.prototype.useCreateStockMovement = function () {
        var _this = this;
        var queryClient = useQueryClient();
        var navigate = useNavigate();
        return useMutation(function (_a) {
            var stockMovement = _a.stockMovement, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            var data = { stock_movement: instanceToPlain(stockMovement) };
            return _this.post(_this.stockMovementsRoot, { data: data });
        }, {
            retry: false,
            onSuccess: function (_data, variables) {
                queryClient.invalidateQueries(queries.inventory.stockMovements);
                queryClient.invalidateQueries(queries.inventory.stocks);
                queryClient.invalidateQueries(queries.inventory.products);
                queryClient.invalidateQueries(['show', queries.inventory.products]);
                _this.dipatachCreationSuccess({ successMessage: _this.successMessage });
                if (!variables.stayOnPage)
                    navigate('/stock_movements');
            }
        });
    };
    StockMovementService.getInstance = function () {
        if (!StockMovementService.stockMovementService) {
            StockMovementService.stockMovementService = new StockMovementService();
        }
        return StockMovementService.stockMovementService;
    };
    return StockMovementService;
}(ApiService));
export default StockMovementService;
